import SEOHead from "@/components/base/SEOHead";
import SchemaOrg from "@/components/base/SchemaOrg";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import Breadcrumb from "@/components/feature/Breadcrumb";
import ScrollToTop from "@/components/feature/ScrollToTop";

const pageTitle = "关于我们 - 91.con 导航";
const pageDescription =
  "91.con导航站致力于为用户提供最新、最全、最安全的91.con官方入口地址导航服务，帮助用户快速找到官方渠道，远离虚假钓鱼网站。";
const canonicalUrl = "https://bosomfriendcat.cn/about";

export default function AboutPage() {
  return (
    <>
      <ScrollToTop />
      <SEOHead
        title={pageTitle}
        description={pageDescription}
        keywords="91.con,91.con导航,关于我们,品牌介绍,联系方式"
        canonicalUrl={canonicalUrl}
      />
      <SchemaOrg
        type="Organization"
        data={{
          name: "91.con 导航",
          url: canonicalUrl,
          description: pageDescription,
          contactPoint: {
            "@type": "ContactPoint",
            email: "contact@bosomfriendcat.cn",
            contactType: "customer service",
          },
        }}
        scriptId="schema-org"
      />
      <SchemaOrg
        type="WebPage"
        data={{
          name: pageTitle,
          description: pageDescription,
          url: canonicalUrl,
        }}
        scriptId="schema-webpage"
      />

      <Navbar />

      <main className="min-h-screen pt-20 bg-background-50">
        {/* Breadcrumb */}
        <div className="bg-background-100 py-6">
          <div className="max-w-7xl mx-auto px-4 md:px-6">
            <Breadcrumb items={[{ label: "首页", href: "/" }, { label: "关于我们" }]} />
          </div>
        </div>

        {/* Brand Introduction */}
        <section className="py-14 md:py-20">
          <div className="max-w-4xl mx-auto px-4 md:px-6">
            <h1 className="text-3xl md:text-4xl font-bold text-foreground-950 text-center">
              关于我们
            </h1>
            <p className="mt-4 text-foreground-500 text-center text-sm max-w-xl mx-auto">
              致力于为 91.con 用户提供安全、可靠、高效的地址导航服务
            </p>

            <div className="mt-12 grid grid-cols-1 md:grid-cols-2 gap-8">
              <div className="bg-background-50 border border-background-200/70 rounded-xl p-6 md:p-8">
                <div className="w-12 h-12 flex items-center justify-center rounded-full bg-primary-100 text-primary-600 mb-4">
                  <i className="ri-star-line text-xl"></i>
                </div>
                <h2 className="text-lg font-bold text-foreground-950 mb-3">品牌介绍</h2>
                <p className="text-sm text-foreground-600 leading-relaxed">
                  91.con 导航站是一家专注于为用户提供 91.con
                  官方入口地址导航服务的专业平台。我们深知用户在访问网络平台时面临的各种困难——地址失效、虚假钓鱼网站、访问不稳定等问题。因此，我们组建了专门的团队，7×24
                  小时持续监控和更新 91.con 的最新可用地址，确保用户能够安全、稳定地访问目标平台。
                </p>
                <p className="mt-3 text-sm text-foreground-600 leading-relaxed">
                  自成立以来，我们已累计服务超过 <strong>10万+</strong> 月活用户，收录并验证超过{" "}
                  <strong>50+</strong> 个可用地址，成为最受用户信赖的 91.con
                  导航平台之一。
                </p>
              </div>

              <div className="bg-background-50 border border-background-200/70 rounded-xl p-6 md:p-8">
                <div className="w-12 h-12 flex items-center justify-center rounded-full bg-accent-100 text-accent-600 mb-4">
                  <i className="ri-flag-line text-xl"></i>
                </div>
                <h2 className="text-lg font-bold text-foreground-950 mb-3">我们的使命</h2>
                <p className="text-sm text-foreground-600 leading-relaxed">
                  我们的使命是成为用户访问 91.con 的首选导航入口，通过提供实时更新的地址信息、专业的安全指引和详细的常见问题解答，帮助每一位用户顺畅访问平台，远离网络风险。
                </p>
                <ul className="mt-4 space-y-2.5">
                  {[
                    "7×24 小时实时监控地址可用性",
                    "人工审核验证所有收录地址",
                    "定期更新安全访问指引",
                    "快速响应用户反馈与问题",
                    "持续优化用户体验",
                  ].map((item, i) => (
                    <li key={i} className="flex items-start gap-2 text-sm text-foreground-600">
                      <i className="ri-check-line text-accent-500 mt-0.5 flex-shrink-0"></i>
                      <span>{item}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        </section>

        {/* Reputation Section */}
        <section className="py-14 md:py-20 bg-background-100">
          <div className="max-w-7xl mx-auto px-4 md:px-6">
            <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 text-center">
              信誉与承诺
            </h2>
            <p className="mt-3 text-foreground-500 text-center text-sm">
              我们的每一步努力，只为给您最安心的访问体验
            </p>

            <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
              {[
                {
                  icon: "ri-shield-check-line",
                  title: "安全可靠",
                  desc: "所有收录地址均经过人工审核验证，使用HTTPS加密传输，确保访问安全",
                },
                {
                  icon: "ri-refresh-line",
                  title: "实时更新",
                  desc: "7×24小时监控地址状态，发现失效立即更新，确保信息始终准确",
                },
                {
                  icon: "ri-user-heart-line",
                  title: "用户至上",
                  desc: "以用户体验为核心，提供简洁明了的导航界面和详细的使用帮助",
                },
                {
                  icon: "ri-eye-line",
                  title: "公开透明",
                  desc: "所有地址来源公开透明，定期发布更新日志，接受用户监督",
                },
              ].map((item, index) => (
                <div
                  key={index}
                  className="bg-background-50 border border-background-200/70 rounded-xl p-6 text-center"
                >
                  <div className="w-14 h-14 mx-auto flex items-center justify-center rounded-full bg-secondary-100 text-secondary-600 mb-4">
                    <i className={`${item.icon} text-xl`}></i>
                  </div>
                  <h3 className="font-semibold text-foreground-950 mb-2">{item.title}</h3>
                  <p className="text-xs text-foreground-500 leading-relaxed">{item.desc}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Contact Section */}
        <section className="py-14 md:py-20 bg-background-50">
          <div className="max-w-4xl mx-auto px-4 md:px-6">
            <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 text-center">
              联系我们
            </h2>
            <p className="mt-3 text-foreground-500 text-center text-sm">
              如果您有任何问题、建议或反馈，欢迎随时与我们联系
            </p>

            <div className="mt-10 grid grid-cols-1 md:grid-cols-3 gap-5">
              <div className="bg-background-50 border border-background-200/70 rounded-xl p-6 text-center">
                <div className="w-12 h-12 mx-auto flex items-center justify-center rounded-full bg-primary-100 text-primary-600 mb-4">
                  <i className="ri-mail-line text-xl"></i>
                </div>
                <h3 className="font-semibold text-foreground-950 mb-2">电子邮箱</h3>
                <p className="text-sm text-foreground-500">contact@bosomfriendcat.cn</p>
              </div>
              <div className="bg-background-50 border border-background-200/70 rounded-xl p-6 text-center">
                <div className="w-12 h-12 mx-auto flex items-center justify-center rounded-full bg-accent-100 text-accent-600 mb-4">
                  <i className="ri-time-line text-xl"></i>
                </div>
                <h3 className="font-semibold text-foreground-950 mb-2">服务时间</h3>
                <p className="text-sm text-foreground-500">7×24小时全天候服务</p>
              </div>
              <div className="bg-background-50 border border-background-200/70 rounded-xl p-6 text-center">
                <div className="w-12 h-12 mx-auto flex items-center justify-center rounded-full bg-secondary-100 text-secondary-600 mb-4">
                  <i className="ri-message-2-line text-xl"></i>
                </div>
                <h3 className="font-semibold text-foreground-950 mb-2">反馈建议</h3>
                <p className="text-sm text-foreground-500">欢迎通过邮箱提交反馈</p>
              </div>
            </div>

            {/* Contact Form */}
            <div className="mt-11 bg-background-50 border border-background-200/70 rounded-xl p-6 md:p-8">
              <h3 className="text-lg font-bold text-foreground-950 mb-6">发送消息</h3>
              <ContactForm />
            </div>
          </div>
        </section>

        {/* Disclaimer */}
        <section className="py-10 bg-background-100">
          <div className="max-w-4xl mx-auto px-4 md:px-6">
            <div className="bg-background-50 border border-background-200/70 rounded-xl p-6">
              <h2 className="text-sm font-bold text-foreground-950 mb-3">免责声明</h2>
              <p className="text-xs text-foreground-500 leading-relaxed">
                本站（91.con导航）为第三方导航平台，与91.con平台无直接关联。本站仅提供地址导航和索引服务，不存储、不传输任何第三方平台的内容。所有收录的地址信息均来自公开渠道，我们不对第三方平台的可用性、内容合法性及服务质量负责。用户在使用过程中应遵守相关法律法规，如发现任何问题请及时联系我们。
              </p>
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </>
  );
}

// Contact Form Component
import { useState, FormEvent } from "react";

function ContactForm() {
  const [formState, setFormState] = useState<"idle" | "submitting" | "success" | "error">("idle");
  const [errorMessage, setErrorMessage] = useState("");
  const [charCount, setCharCount] = useState(0);

  const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setFormState("submitting");
    setErrorMessage("");

    const form = e.currentTarget;
    const honeypot = (form.querySelector('input[name="phone_alt"]') as HTMLInputElement)?.value?.trim();
    if (honeypot) {
      setFormState("success");
      return;
    }

    try {
      const formData = new FormData(form);
      formData.delete("phone_alt");
      const urlSearchParams = new URLSearchParams();
      formData.forEach((value, key) => {
        urlSearchParams.append(key, value as string);
      });

      const response = await fetch("https://readdy.ai/api/form/d9pj7j5i2vhsdh2d35s0", {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: urlSearchParams.toString(),
      });

      const responseText = await response.text();
      let parsed;
      try {
        parsed = JSON.parse(responseText);
      } catch {
        parsed = null;
      }

      if (response.ok && parsed?.code === "OK") {
        setFormState("success");
        form.reset();
        setCharCount(0);
      } else {
        const serverMsg =
          parsed?.meta?.message || parsed?.message || parsed?.meta?.detail || responseText || "提交失败，请稍后重试";
        if (typeof serverMsg === "string" && serverMsg.includes("spam")) {
          setErrorMessage("提交失败，请稍后重试");
        } else {
          setErrorMessage(typeof serverMsg === "string" ? serverMsg : "提交失败，请稍后重试");
        }
        setFormState("error");
      }
    } catch {
      setErrorMessage("网络错误，请检查您的网络连接后重试");
      setFormState("error");
    }
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-5" data-readdy-form="">
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
        <div>
          <label htmlFor="contact-name" className="block text-sm font-medium text-foreground-700 mb-1.5">
            姓名 <span className="text-red-500">*</span>
          </label>
          <input
            id="contact-name"
            name="name"
            type="text"
            required
            className="w-full px-4 py-2.5 rounded-lg border border-background-200 bg-background-50 text-foreground-950 text-sm focus:outline-none focus:border-primary-300 focus:ring-1 focus:ring-primary-200 transition-colors"
            placeholder="请输入您的姓名"
          />
        </div>
        <div>
          <label htmlFor="contact-email" className="block text-sm font-medium text-foreground-700 mb-1.5">
            邮箱 <span className="text-red-500">*</span>
          </label>
          <input
            id="contact-email"
            name="email"
            type="email"
            required
            className="w-full px-4 py-2.5 rounded-lg border border-background-200 bg-background-50 text-foreground-950 text-sm focus:outline-none focus:border-primary-300 focus:ring-1 focus:ring-primary-200 transition-colors"
            placeholder="请输入您的邮箱"
          />
        </div>
      </div>

      <div>
        <label htmlFor="contact-subject" className="block text-sm font-medium text-foreground-700 mb-1.5">
          主题 <span className="text-red-500">*</span>
        </label>
        <input
          id="contact-subject"
          name="subject"
          type="text"
          required
          className="w-full px-4 py-2.5 rounded-lg border border-background-200 bg-background-50 text-foreground-950 text-sm focus:outline-none focus:border-primary-300 focus:ring-1 focus:ring-primary-200 transition-colors"
          placeholder="请输入消息主题"
        />
      </div>

      <div>
        <label htmlFor="contact-message" className="block text-sm font-medium text-foreground-700 mb-1.5">
          消息内容 <span className="text-red-500">*</span>
          <span className="text-foreground-400 font-normal ml-2">（{charCount}/500）</span>
        </label>
        <textarea
          id="contact-message"
          name="message"
          required
          rows={5}
          maxLength={500}
          onChange={(e) => setCharCount(e.target.value.length)}
          className="w-full px-4 py-2.5 rounded-lg border border-background-200 bg-background-50 text-foreground-950 text-sm focus:outline-none focus:border-primary-300 focus:ring-1 focus:ring-primary-200 transition-colors resize-none"
          placeholder="请输入您的消息内容..."
        />
      </div>

      {/* Honeypot */}
      <input
        type="text"
        name="phone_alt"
        tabIndex={-1}
        autoComplete="off"
        aria-hidden="true"
        readOnly
        className="absolute opacity-0 pointer-events-none"
        style={{ position: "absolute", left: "-9999px" }}
      />

      <div className="flex items-center gap-4">
        <button
          type="submit"
          disabled={formState === "submitting" || charCount > 500}
          className="inline-flex items-center gap-2 px-8 py-3 bg-primary-500 hover:bg-primary-600 disabled:opacity-50 disabled:cursor-not-allowed text-white font-semibold rounded-full text-sm whitespace-nowrap transition-colors cursor-pointer"
        >
          {formState === "submitting" ? (
            <>
              <i className="ri-loader-4-line animate-spin"></i>
              提交中...
            </>
          ) : (
            <>
              <i className="ri-send-plane-line"></i>
              发送消息
            </>
          )}
        </button>
        {formState === "success" && (
          <span className="text-sm text-accent-600 font-medium flex items-center gap-1.5">
            <i className="ri-check-line"></i>
            消息已发送成功！
          </span>
        )}
        {formState === "error" && (
          <span className="text-sm text-red-500 flex items-center gap-1.5">
            <i className="ri-error-warning-line"></i>
            {errorMessage}
          </span>
        )}
      </div>
    </form>
  );
}